import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { UserContext } from './../UserContext';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import { useUserDetails } from './../useUserDetails';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import BillingDetails from './BillingDetails';
import {
  MyProfileIcon,
  BillingsAndPaymentsIcon,
  ChangePasswordIcon,
  LogoutIcon,
  UserManagementIcon,
} from './Icons';
import Tooltip from '@material-ui/core/Tooltip';

const logoutPath = '/api/auth/logout';
const logoutWithResetPath = '/api/auth/logoutWithReset';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  leftPadded: {
    paddingLeft: theme.spacing(3),
  },
  avatar: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  menuItem: {
    color: theme.palette.primary.main,
  },
  listIcon: {
    minWidth: theme.spacing(4),
  },
  menuItemChip: {
    color: theme.palette.primary.main,
    textAlign: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'none',
    minHeight: theme.spacing(5),
  },
  rightPadded: {
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(0.6),
  },
  userName: {
    maxWidth: 532,
  },
  tooltip: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '100%',
  },
  paperMenu: {
    top: '69px !important',
  },
}));

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const USER_MANAGEMENT_PATH = '/home/settings/users';
const BILLING_PAYMENTS_PATH = '/home/settings/billing-details';
const MY_PROFILE_PATH = '/home/settings/my-profile';

export function UserInfo(props) {
  const classes = useStyles();
  const { doesNotHaveTenant } = props;
  const history = useHistory();
  const { user } = useContext(UserContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const { success, data: userDetails } = useUserDetails();
  const username = user.getFullName();
  const topRoleLabel = user.getTopRoleLabel();
  const initials = user.getInitials();
  const isUserManagementAllowed = user.isUserManagementAllowed();
  const isBillingAllowed = user.isBillingAllowed();
  const isDemoUser = user.isDemoUser();
  const sso = user.getSSO();
  const isSSO = sso === true || sso === "true" ? true : false;
  const isSiaaAgency = user.isSiaaAgency();

  let avatarURL;
  if (success) {
    ({ avatarURL } = userDetails);
  }
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    window.location.href = logoutPath + "?fromLogoutButton=true";
  };
  const handleChangePassword = () => {
    window.location.href = logoutWithResetPath;
  };
  const handleUserManagement = () => {
    handleClose();
    history.push(USER_MANAGEMENT_PATH);
  };
  const handleBillingPayments = () => {
    handleClose();
    history.push(BILLING_PAYMENTS_PATH);
  };
  const handleMyProfile = () => {
    handleClose();
    history.push(MY_PROFILE_PATH);
  };
  return (
    <div className={classes.root}>
      {!isSiaaAgency && <LightTooltip title={`${username} (${topRoleLabel})`} arrow>
        <Typography
          variant="h6"
          noWrap
          className={classes.userName}
        >{`${username} (${topRoleLabel})`}</Typography>
      </LightTooltip>}
      {isSiaaAgency && <LightTooltip title={`${username}`} arrow>
        <Typography
          variant="h6"
          noWrap
          className={classes.userName}
        >{`${username}`}</Typography>
      </LightTooltip>}
      <IconButton
        aria-label="profile"
        aria-controls="profile-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Avatar alt={username} className={classes.avatar} src={avatarURL}>
          {initials}
        </Avatar>
      </IconButton>
      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        classes={{ paper: classes.paperMenu }}
      >
        {!doesNotHaveTenant && (
          <>
            <div className={classes.menuItemChip}>
              <BillingDetails />
            </div>
            {!isDemoUser && (
              <MenuItem className={classes.menuItem} onClick={handleMyProfile}>
                <ListItemIcon className={classes.listIcon}>
                  <MyProfileIcon />
                </ListItemIcon>
                My Profile
              </MenuItem>
            )}
            {isUserManagementAllowed && !isDemoUser && (
              <MenuItem className={classes.menuItem} onClick={handleUserManagement}>
                <ListItemIcon className={classes.listIcon}>
                  <UserManagementIcon />
                </ListItemIcon>
                User Management
              </MenuItem>
            )}
            {!isSiaaAgency && isBillingAllowed && !isDemoUser && (
              <MenuItem
                className={classes.menuItem}
                onClick={handleBillingPayments}
              >
                <ListItemIcon className={classes.listIcon}>
                  <BillingsAndPaymentsIcon />
                </ListItemIcon>
                Billing and Payments
              </MenuItem>
            )}
            {!isSSO && !isDemoUser && (
              <MenuItem className={classes.menuItem} onClick={handleChangePassword}>
                <ListItemIcon className={classes.listIcon}>
                  <ChangePasswordIcon />
                </ListItemIcon>
                Change Password
              </MenuItem>
            )}
          </>
        )}
        <MenuItem className={classes.menuItem} onClick={handleLogout}>
          <ListItemIcon className={classes.listIcon}>
            <LogoutIcon />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
}
